import * as yup from "yup";

import { addKeyToFieldsRecursively } from "@/react/schema";

const JobNames = Object.freeze({
  CREATE_QUEUES: "ACTION_CREATE_QUEUES",
  CREATE_PBXS: "ACTION_CREATE_PBXS",
});

const Statuses = Object.freeze({
  PROCESSED: "PROCESSED",
  SUCCEEDED: "SUCCEEDED",
  FAILED: "FAILED",
  PENDING: "PENDING",
  UNKNOWN: "UNKNOWN",
});

const JobSources = Object.freeze({
  VCCSSCM: "VCCSSCM",
  TAP: "TAP",
});

const schema = yup.object({
  jobId: yup.string().uuid().required(),
  customerId: yup.string().required(),
  details: yup.string().required(),
  userId: yup.string().required(),
  action: yup.string().oneOf(Object.values(JobNames)).required(),
  status: yup.string().oneOf(Object.values(Statuses)).required(),
  source: yup.string().oneOf(Object.values(JobSources)).required(),
  stats: yup
    .object({
      successes: yup.number().integer().required(),
      failures: yup.number().integer().required(),
      totalJobs: yup.number().integer().required(),
    })
    .required(),
  jobData: yup.object(),
  createdAt: yup.string().required(),
  updatedAt: yup.string().required(),
  completedAt: yup.string().required(),
});

export default addKeyToFieldsRecursively(schema);
export { JobNames, Statuses, JobSources };
